import { useMutation, useQueryClient } from '@tanstack/react-query';

import flexControlsClient, {
    AccountFlexControlsPayload,
} from '@clients/domains/flexControls/flexControlsClient';
import notifyAPIError from '@utils/notifyAPIError';

interface patchUpdateAccountFlexControlOptions {
    accountId: number;
    flexControlId: string;
    onSuccess?: () => void;
    onError?: () => void;
}

const { patchUpdateAccountFlexControl } = flexControlsClient();

const usePatchUpdateAccountFlexControl = ({
    accountId,
    flexControlId,
    onSuccess,
    onError,
}: patchUpdateAccountFlexControlOptions) => {
    const queryClient = useQueryClient();
    const { data, error, isError, isLoading, isSuccess, mutate } = useMutation(
        ['patchUpdateAccountFlexControl', accountId, flexControlId],
        (dataToSubmit: AccountFlexControlsPayload) =>
            patchUpdateAccountFlexControl({
                accountId,
                flexControlId,
                dataToSubmit,
            }),
        {
            onSuccess: () => {
                try {
                    queryClient.invalidateQueries(['getFlexControlAccount']);
                } catch {
                    console.error(
                        `Unable to invalidate cache for ['getFlexControlAccount', {accountId: ${accountId}, flexId : ${flexControlId}}]`,
                    );
                }
                onSuccess?.();
            },
            onError: (error) => {
                notifyAPIError(error);
                onError?.();
            },
        },
    );

    return { data, error, isError, isLoading, isSuccess, mutate };
};

export default usePatchUpdateAccountFlexControl;
